export default __webpack_public_path__ + "static/media/instagram-sketched.e719d8b2.png";